import { useState, useMemo } from "react";
import { Package, MapPin, ChevronDown, ChevronUp } from "lucide-react";
import { StateManager } from "../service/StateManager";
import "../../../css/OnRoad.css";

export default function RemesaGroupByRoute({ grupoRuta }) {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpanded = () => {
        setIsExpanded(prev => !prev);
    };

    const { origen, destino, remesas } = grupoRuta;
    const totalRemesas = remesas.length;
    const remesaReferencia = remesas[0];

    const estadoOperativoGrupo = useMemo(() => {
        return StateManager.determinarEstadoOperativoGrupo(grupoRuta);
    }, [grupoRuta]);

    // Calcular estadísticas de progreso para este grupo
    const calcularEstadisticas = () => {
        const totalEventos = 4; // 2 cargue + 2 descargue
        let eventosCompletados = 0;

        if (remesaReferencia.fecha_llegada_cargue) eventosCompletados++;
        if (remesaReferencia.fecha_salida_cargue) eventosCompletados++;
        if (remesaReferencia.fecha_llegada_descargue) eventosCompletados++;
        if (remesaReferencia.fecha_salida_descargue) eventosCompletados++;

        return {
            completados: eventosCompletados,
            total: totalEventos,
            porcentaje: Math.round((eventosCompletados / totalEventos) * 100)
        };
    };

    const estadisticas = calcularEstadisticas();

    return (
        <div className="remesa-details-section">
            {/* Header clickeable para expandir/colapsar */}
            <div 
                className={`remesa-header clickeable ${isExpanded ? 'expanded' : ''}`}
                onClick={toggleExpanded}
                role="button"
                aria-expanded={isExpanded}
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleExpanded();
                    }
                }}
            >
                <MapPin size={18} />
                <span className="remesa-title">
                    {origen} → {destino}
                </span>
                <span className="remesa-count">
                    {totalRemesas} remesa{totalRemesas !== 1 ? 's' : ''}
                </span>
                <div className="expand-icon">
                    {isExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </div>
            </div>
            
            {/* Contenido desplegable */}
            <div className={`remesas-content ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <div className="remesas-grid">
                    {remesas.map((remesa, index) => (
                        <div key={remesa.id || index} className="remesa-card">
                            <div className="remesa-card-header">
                                <Package size={16} />
                                <span className="remesa-id">{remesa.consecutivo}</span>
                            </div>
                            <div className="remesa-info">
                                <div className="info-item">
                                    <span className="info-label">Producto:</span>
                                    <span className="info-value">{remesa.producto}</span>
                                </div>
                                <div className="info-item">
                                    <span className="info-label">Cliente:</span>
                                    <span className="info-value">{remesa.nombre_propietario}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Información adicional del grupo */}
                <div className="grupo-info-section">
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="info-label">Total remesas:</span>
                            <span className="info-value">{totalRemesas}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Estado operativo:</span>
                            <span className={`info-badge ${estadoOperativoGrupo.toLowerCase().replace(/\s+/g, '-')}`}>
                                {estadoOperativoGrupo}
                            </span>
                        </div>
                        <div className="info-item full-width">
                            <span className="info-label">Progreso:</span>
                            <span className="info-value">
                                {estadisticas.completados}/{estadisticas.total} eventos
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}